<template>
  <b-card class="my-4">
    <FormulateForm
      v-model="formValues"
      ref="form-ref"
      :errors="formErrors"
      @input="handleInputForm"
    >
      <!-- Basic Info Section -->
      <h4 class="card-title">Informasi Penjadwalan</h4>
      <BasicInfoSection />

      <hr />

      <!-- Recurrence Info Section -->
      <h4 class="card-title">Perulangan</h4>
      <RecurrenceInfoSection :formValues="formValues" :recurrenceData="recurrenceData">
        <template #weekly-checkbox>
          <div v-for="item in dayItems" class="d-flex gap-1">
            <McCheckbox
              v-model="formValues.selectedWeeklyDays"
              :id="item.key"
              :value="item.key"
              :disabled="isLoading"
            />
            <label class="m-0" :for="item.key">
              {{ item.label }}
            </label>
          </div>
        </template>
      </RecurrenceInfoSection>
    </FormulateForm>
  </b-card>
</template>

<script>
import McCheckbox from '@/components/McCheckbox'

import BasicInfoSection from '../components/BasicInfoSection'
import RecurrenceInfoSection from '../components/RecurrenceInfoSection'

import moment from 'moment'
import cloneDeep from 'lodash/cloneDeep'
import { debounce } from '@/helpers/debounce'

import { formValuesToRruleString } from '../helpers/rrule.js'
import * as DeliveryScheduler from '@/services/rest-api/lib/scheduler/scheduler'
import { dayItems } from '../lib/constants/mappings.js'
import errorMappings from '../lib/constants/error-mappings.js'

export default {
  components: {
    McCheckbox,
    BasicInfoSection,
    RecurrenceInfoSection,
  },
  inject: ['isLoading'],
  emits: ['update:isLoading'],
  data() {
    return {
      formValues: {
        startDate: moment(new Date().setHours(0, 0, 0, 0)).format('YYYY-MM-DDTHH:mm:ss.SSSZ'),
        recurrenceValue: 1,
        recurrenceType: 'DAILY',
        recurrenceTime: moment().format('HH:mm'),
        selectedWeeklyDays: ['MO'],
        selectedMonthlyDate: 1,
        endDate: null,
      },
      initialFormValues: {},
      formErrors: {},
      invalidFormValues: {},

      recurrenceData: {},

      dayItems,
    }
  },
  watch: {
    formValues(newValue) {
      if (Object.keys(this.formErrors).length === 0) return

      for (const [key, _] of Object.entries(this.invalidFormValues)) {
        if (this.invalidFormValues[key] === newValue[key]) continue

        this.$delete(this.formErrors, key)
        this.$delete(this.invalidFormValues, key)
      }
    },
  },
  mounted() {
    this.initialFormValues = cloneDeep(this.formValues)
  },
  methods: {
    GetFormValues() {
      if (this.$refs['form-ref'].hasErrors) {
        this.$refs['form-ref'].showErrors()
        this.$mcToast.error('Terdapat kesalahan format pada input anda')

        return null
      }

      return this.formValues
    },

    handleInputForm: debounce(async function (data) {
      if (this.initialFormValues.name !== this.formValues.name) {
        this.initialFormValues = cloneDeep(data)
        return
      }

      const rule = formValuesToRruleString(data)
      const res = await DeliveryScheduler.helper({ rule })

      if (res.errors) {
        return
      }

      this.recurrenceData = res.data
      this.initialFormValues = cloneDeep(data)
    }, 500),

    AssignErrors(errors) {
      if (Object.keys(errors).length === 0) return

      for (const [key, value] of Object.entries(errors)) {
        let message = errorMappings[key][value[0]]
        this.$set(this.formErrors, key, message)
        this.$set(this.invalidFormValues, key, this.formValues[key])
      }
    },
  },
}
</script>
